<template>
  <v-container id="alerts" fluid tag="section">
    <div class="text-right">
      <loading :active.sync="isLoading" :can-cancel="false" loader="dots" color="#007bff" :height="45" :width="75"
        :is-full-page="fullPage" />
    </div>
    <v-row>
      <v-col cols="6">
        <v-autocomplete v-model="form.user_email" :items="userSuggestions" :loading="isUserLoading" label="User"
          placeholder="Please enter email (min 4 characters)" hide-no-data clearable dense no-filter
          @update:search-input="onUserSearch" />
      </v-col>
      <v-col cols="6">
        <v-select v-model="form.Activity" label="Activity" :items="activityOptions" item-text="text" item-value="value"
          dense />
      </v-col>

    </v-row>
    <v-row class="mt-5 mb-0">
      <v-col cols="6">
        <v-menu ref="fromMenu" v-model="fromMenu" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="290px">
          <template #activator="{ on, attrs }">
            <v-text-field v-model="form.startDate" label="From Date" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="form.startDate" :max="max" @input="fromMenu = false" />
        </v-menu>
      </v-col>

      <v-col cols="6">
        <v-menu ref="toMenu" v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="290px">
          <template #activator="{ on, attrs }">
            <v-text-field v-model="form.endDate" label="To Date" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="form.endDate" :max="max" @input="toMenu = false" />
        </v-menu>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="4">
        <v-btn small color="primary" @click="search" :disabled="isActionDisabled">
          Search
        </v-btn>
        <v-btn small color="default" @click="reset">
          Reset
        </v-btn>
      </v-col>
      <v-col cols="8">
        <div style="float: right">
          <v-btn small color="primary" @click="exportSearchData" :disabled="isExportDisabled">
            Export
          </v-btn>

        </div>
        <div style="float: right">
          <v-btn small color="primary" @click="loadWeeklyReport" :disabled="isActionDisabled">Weekly Report</v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="username || userEmail || companyName" class="ml-1 mt-3">
      <v-col cols="3">
        <strong>User Name:</strong> {{ username }}
      </v-col>
      <v-col cols="6">
        <strong>Email Address:</strong> {{ userEmail }}
      </v-col>
      <v-col cols="3">
        <strong>Company:</strong> {{ companyName }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="items" :loading="isLoading" :items-per-page="perpage" item-key="userID"
          :options.sync="options" class="elevation-1" hide-default-footer>
          <template v-slot:item.queryDate="{ item }">
            <div class="align-top-cell">
              {{ formatDate(item.queryDate) }}
            </div>
          </template>

          <template v-slot:item.searchCriteria="{ item }">
            <div v-html="item.searchCriteria"></div>
          </template>

          <template v-slot:item.total_download="{ item }">
            <div class="align-top-cell">
              {{ item.total_download || 0 }}
            </div>
          </template>

          <template v-slot:item.mediaChannel="{ item }">
            <div v-if="item.mediaChannel && item.mediaChannel.length">
              <v-chip v-for="(channel, index) in item.mediaChannel.slice(0, 3)" :key="index" small class="ma-1">
                {{ channel }}
              </v-chip>
              <span v-if="item.mediaChannel.length > 3" class="text-caption">
                +{{ item.mediaChannel.length - 3 }} more
              </span>
            </div>
            <span v-else>N/A</span>
          </template>

          <template v-slot:item.sector="{ item }">
            <div v-if="item.sector && item.sector.length">
              <v-chip v-for="(sec, index) in item.sector.slice(0, 2)" :key="index" small class="ma-1">
                {{ sec }}
              </v-chip>
              <span v-if="item.sector.length > 2" class="text-caption">
                +{{ item.sector.length - 2 }} more
              </span>
            </div>
            <span v-else>N/A</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon medium color="grey" @click="updateUser(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>

        <div class="text-center pt-4 pb-4">
          <Pagination :isloading="isLoading" :startRecord="startRecord" :currentPage="page" :lastPage="lastPage"
            :lastRecord="lastRecord" :totRecords="totRecords" :isCurrentPageClass="isCurrentPageClass"
            :getLastPageClass="getLastPageClass" :totPage="totPage" :perpage="perpage" :getPages="getPages"
            @handlePerPage="handlePerPage" @paginate="paginate" @last="last" @getDataByPage="getDataByPage"
            :showPerPage="showPerPage" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Pagination from "./component/Pagination.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  name: "TrendReport",
  components: {
    Loading,
    Pagination,
  },
  data: () => ({
    userSuggestions: [],
    isUserLoading: false,
    dateValidationDialog: false,
    validationMessage: '',
    username: '',
    userEmail: '',
    searchQuery: '',
    companyName: '',
    userSearchTimer: null,
    fromMenu: false,
    toMenu: false,
    currentPage: 1,
    page: 1,
    perpage: 10,
    pageCount: 0,
    totRecords: 0,
    activityOptions: [
      { text: 'All', value: 0 },
      { text: 'Downloaded', value: 1 },
      { text: 'Only Search', value: 2 },
    ],

    // Table headers
    headers: [
      {
        text: "Search Date", value: "queryDate",
        width: "15%",
        align: 'center',
      },
      {
        text: "Search Criteria",
        value: "searchCriteria",
        sortable: false,
        width: "70%",
      },

      {
        text: "Total Downloads",
        value: "total_download",
        sortable: false,
        width: "15%",
      },
    ],

    // Form
    form: {
      user_email: '',
      Activity: 0,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },

    // Table data
    items: [],
    // selected: [],

    // Loading states
    isLoading: false,
    fullPage: true,

    // Misc
    options: {},
    showPerPage: true,
    max: moment(new Date()).format("YYYY-MM-DD"),
  }),

  computed: {
    isExportDisabled() {
      return !this.items.length || !this.form.user_email;
    },
    isActionDisabled() {
      return !this.form.user_email;
    },
    isLoaderVisible() {
      return this.isLoading;
    },
    exportUrl() {
      const fromDate = this.form.startDate;
      const toDate = this.form.endDate;
      const params = new URLSearchParams({
        from_date: fromDate,
        to_date: toDate,
        user_activity: 0,
        export: 1,
        user_email: this.form.user_email || '',
      });

      return `https://dev06.competiscan.com:5012/export-users-csv?${params.toString()}`;
    },
    // Pagination-related
    startRecord() {
      return (this.currentPage - 1) * this.perpage + 1;
    },
    lastRecord() {
      return Math.min(this.currentPage * this.perpage, this.totRecords);
    },
    isCurrentPageClass() {
      return (n) => n === this.page ? "active-page" : "notactivespan";
    },
    getLastPageClass() {
      return this.page === this.lastPage ? "active-page" : "notactivespan";
    },

    totPage() {
      return Math.ceil(this.totRecords / this.perpage);
    },
    getPages() {
      return this.$utils.getPages(this.lastPage, this.currentPage, this.totPage);
    },
    lastPage() {
      return Math.ceil(this.totRecords / this.perpage);
    }
  },

  watch: {
    page() {
      this.fetchUserSearches();
    }
  },

  methods: {
    formatDate(date) {
      if (!date) return 'N/A';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },

    async exportSearchData() {
      const fromDate = this.form.startDate;
      const toDate = this.form.endDate;

      // Validate date range
      if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
        await this.$swal({
          icon: 'error',
          title: 'Invalid Date Range',
          text: "'From Date' cannot be later than 'To Date'.",
          confirmButtonText: 'OK'
        });
        return;
      }

      // Construct URL with query parameters (same as fetchUserSearches)
      const baseUrl = this.$url("USER_EXPORT");
      const params = new URLSearchParams({
        from_date: fromDate,
        to_date: toDate,
        user_activity: this.form.Activity,
        limit: this.perpage,
        page: this.page,
        export: 1,
        user_email: this.form.user_email || '',
      });
      const fullUrl = `${baseUrl}?${params.toString()}`;

      this.isLoading = true;

      try {
        const response = await fetch(fullUrl, {
          method: 'GET',
          headers: {
            Authorization: `${this.$utils.getCookies('access_token')}`
          }
        });

        if (!response.ok) {
          throw new Error(`Export failed: ${response.statusText}`);
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `user_activity_${new Date().toISOString().split('T')[0]}_${Date.now()}.csv`;

        if (contentDisposition) {
          const matchesEncoded = contentDisposition.match(/filename\*\=([^;]+)/);
          if (matchesEncoded) {
            filename = decodeURIComponent(matchesEncoded[1].split("''")[1]);
          } else {
            const matches = contentDisposition.match(/filename="?([^"]+)"?/);
            if (matches && matches[1]) {
              filename = matches[1];
            }
          }
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error('Download error:', error);
        this.$swal({
          icon: 'error',
          title: 'Export Failed',
          text: error.message || 'Something went wrong while exporting data.',
        });
      } finally {
        this.isLoading = false;
      }
    },

    loadWeeklyReport() {
      const today = moment();
      const sevenDaysAgo = moment().subtract(7, 'days');

      this.form.startDate = sevenDaysAgo.format('YYYY-MM-DD');
      this.form.endDate = today.format('YYYY-MM-DD');

      this.currentPage = 1;
      this.fetchUserSearches();
    },

    async fetchUserSearches() {
      this.isLoading = true;
      const url = this.$url("USER_SEARCH_ACTIVITY");
      const fromDate = this.form.startDate;
      const toDate = this.form.endDate;

      if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
        this.isLoading = false;
        await this.$swal({
          icon: 'error',
          title: 'Invalid Date Range',
          text: "'From Date' cannot be later than 'To Date'.",
          confirmButtonText: 'OK'
        });
        this.isLoading = false;
        return;
      }

      const queryParams = {
        from_date: fromDate,
        to_date: toDate,
        user_activity: this.form.Activity,
        limit: this.perpage,
        page: this.page,
        export: 0,
        user_email: this.form.user_email || '',
      };

      try {
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).get(url, { params: queryParams });

        const result = response.data?.data;

        if (result?.search_result && Array.isArray(result.search_result)) {
          const user = result.user_data || {};

          this.username = user.username || 'N/A';
          this.userEmail = user.emailAddress || 'N/A';
          this.companyName = user.companyName || 'N/A';
          this.items = result.search_result.map(entry => ({
            queryDate: entry["Search Date"],
            total_download: entry["Total Download"],
            searchCriteria: this.formatSearchCriteria(entry["Search Criteria"]),
            mediaChannel: entry["Search Criteria"]?.["Media Channel"] || [],
            sector: entry["Search Criteria"]?.["Sector"] || [],
            username: user.username || 'N/A',
            companyName: user.companyName || 'N/A',
          }));

          this.totRecords = result.total_count || 0;

        } else {
          this.items = [];
          this.totRecords = 0;

          this.username = '';
          this.userEmail = '';
          this.companyName = '';
        }

        this.pageCount = Math.ceil(this.totRecords / this.perpage);
      } catch (error) {
        console.error("Error fetching user search data:", error);
        this.items = [];
        this.totRecords = 0;
        this.pageCount = 0;

        this.username = '';
        this.userEmail = '';
        this.companyName = '';
      } finally {
        this.isLoading = false;
      }
    },

    onUserSearch(query) {
      this.searchQuery = query;

      if (this.userSuggestions.includes(query)) {
        return;
      }

      if (this.userSearchTimer) clearTimeout(this.userSearchTimer);

      if (query.length < 4) {
        this.userSuggestions = [];
        return;
      }

      this.userSearchTimer = setTimeout(async () => {
        this.isUserLoading = true;
        try {
          const url = this.$url("USER_LIST_ACTIVITY");
          const response = await this.$fetch({
            requiresAuth: true,
            operation: "view",
            vueScope: this,
          }).get(url, {
            params: {
              user_email: query,
            },
          });

          const users = response.data?.data || [];
          this.userSuggestions = users.map(user => user.emailAddress);
        } catch (error) {
          console.error("Error fetching user list:", error);
          this.userSuggestions = [];
        } finally {
          this.isUserLoading = false;
        }
      }, 400);
    },

    formatSearchCriteria(criteria) {
      if (!criteria || typeof criteria !== 'object') return 'N/A';

      const parts = [];

      for (const key in criteria) {
        const value = criteria[key];

        let formattedValue = '';

        if (Array.isArray(value)) {
          formattedValue = value.length ? value.join(', ') : '';
        } else if (typeof value === 'string') {
          formattedValue = value.trim();
        }

        if (formattedValue) {
          parts.push(`<strong>${key}:</strong> ${formattedValue}`);
        }
      }

      return parts.length ? parts.join('  ') : 'N/A';
    },

    search() {
      this.currentPage = 1;
      this.fetchUserSearches();
    },

    reset() {
      this.form.user_email = '';
      this.form.Activity = '';
      this.form.startDate = '';
      this.form.endDate = '';
    },

    getDataByPage(value) {
      this.page = value;
    },

    handlePerPage(value) {
      this.perpage = value;
      if (this.page !== 1) {
        this.page = 1;
      } else {
        this.fetchUserSearches();
      }
    },

    paginate(n) {
      if (n == 0) {
        // First page
        this.page = 1
      } else {
        const nextPage = this.page + n;
        this.page = Math.min(Math.max(1, nextPage), this.pageCount)
      }
    },

    last() {
      this.page = this.lastPage;
    },

    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(this, type);
    },
  },

  // created() {
  //   this.fetchUserSearches();
  // },
};
</script>
<style scoped>
.search-padding {
  padding: 0px !important;
}

#required {
  color: red;
}

#approved {
  color: red;
}

.custom-input {
  padding-top: 22px !important;
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.menu-position {
  min-width: auto;
  top: 340px !important;
  transform-origin: left top;
  z-index: 204;
}

.search-criteria {
  line-height: 1.6;
  font-size: 14px;
}

.search-criteria strong {
  color: #2c3e50;
}

.align-top-cell {
  display: flex;
  align-items: flex-start !important;
  justify-content: center !important;
  height: 100%;
}

.active-page {
  background-color: #1976d2;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
}

.notactivespan {
  color: #666;
  cursor: pointer;
}
</style>